export const GAME_YEARS = 3;

export const DISASTER_DRAWS_PER_YEAR = {
  1: 1,
  2: 2,
  3: 3
};

export const TOTAL_DISASTER_DRAWS = 6;

export const FOSSIL_SUBSIDY_MULTIPLIER = 0.5;

export const SHORTFALL_TIER1_LIMIT_MWH = 5;
export const SHORTFALL_TIER1_RATE_PER_MWH = 4;
export const SHORTFALL_TIER2_RATE_PER_MWH = 9;

export const EOS_DUPLICATE_MULTIPLIER = 0.5;
export const OPEX_FLOOR = 0.5;
